module.exports = __webpack_public_path__ + "img/img2.7e876342.jpg";